import request from '@/utils/request'
import host from '@/api/base/host'

// 用户身份
const goods = host.path('dev', { module: 'order', dev: 'v1/user/myinfo' })

export default {
  // 获取用户身份信息/商品购买信息
  getGoodsPrivilege(data) {
    return request({ url: goods('getGoodsPrivilege'), method: 'post', data })
  }
}
